module.exports = __webpack_public_path__ + "img/22(1).4f4430cb.png";